export const SUNSET_PAYWALL_COPY = {
  title: 'Studio has been upgraded to Unlimited',
  intro: [
    'We\'re closing Studio and bringing everyone over to Unlimited. Same live Sessions, with the same Musicians plus 100+ more.',
    'Better search, dashboard, and new features every month.'
  ],
  benefits: [
    { icon: 'dollar', text: '$1 for your first month, $249 after' },
    { icon: 'green-tick', text: 'Pause or cancel anytime' }
  ],
  ctaLabel: 'Upgrade to Unlimited',
  migratePrompt: 'Already on Unlimited?',
  migrateLabel: 'Move my account over'
};

export const SUNSET_PAYWALL_ONDEMAND_COPY = {
  title: 'Studio has been upgraded to Unlimited',
  intro: [
    'We\'re closing Studio and bringing everyone over to Unlimited. Same live Sessions, with the same Musicians plus 100+ more.',
    'Better search, dashboard, and new features every month.'
  ],
  benefits: [
    { icon: 'dollar', text: '$1 for your first month, $249 after' },
    { icon: 'green-tick', text: 'Pause or cancel anytime' }
  ],
  ctaLabel: 'Upgrade to Unlimited',
  sessionsPrompt: 'In the meantime, you can still see your sessions',
  sessionsLabel: 'here',
  supportPrompt: 'Questions? Reach out to',
  supportEmail: 'support@musiversal.com'
};
